// Departments API — typed-обёртка над GET /api/departments (R30 / U-14).
// Backend: DepartmentController.java — list возвращает List<DepartmentDto> (массив,
// без пагинации), доступен ролям ADMIN/DEPARTMENT_HEAD/USER.

import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

/** DTO департамента (wire-формат backend DepartmentDto). */
export interface Department {
  id: string;
  parentId: string | null;
  name: string;
  code: string;
  managerUserId: string | null;
  path: string;
  createdAt: string;
}

/** staleTime для списка департаментов: оргструктура меняется редко. */
const DEPARTMENTS_STALE_TIME_MS = 5 * 60 * 1000;

/** Departments API. */
export const departmentsApi = {
  /** GET /api/departments → Department[] (массив, не Page). */
  async list(): Promise<Department[]> {
    const { data } = await apiClient.get<Department[]>('/api/departments');
    return data;
  },
};

/** TanStack Query hook: список департаментов для Select'ов форм (U-14). */
export function useDepartments(): Department[] | undefined {
  const query = useQuery({
    queryKey: ['departments'],
    queryFn: () => departmentsApi.list(),
    staleTime: DEPARTMENTS_STALE_TIME_MS,
    retry: false,
  });
  return query.data;
}
